import { useRef, useState } from 'react'
import { assetsListModel } from '../assetsListModel'
import Modal from 'antd/lib/modal/Modal'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { message } from 'antd'
import { ISelectOptions } from '@/types/AppTypes'
import useGlobalModel from '@/model/globalModel'
import { warehouseService } from '@/views/base/warehouseManage/warehouseService'
import { globalPrompt } from '@/components/message'
import { assetsListService } from '../assetsListService'

export const ChangeWarehouseModel = ({ visible, setVisible }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg, userList, userData } = useGlobalModel()
    const { selectedIdKeys, setSelectedIdKeys, selectedRowKeys, setSelectedRowKeys, resetSearchParam } = assetsListModel()
    const formRef = useRef<IYhFormRef>()
    const [data, setData] = useState<any>({ warehouseCode: '', warehouseName: '', shelfCode: '' })
    const [shelfAllList, setShelfAllList] = useState<any>([])
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => {
            return { ...item, label: item.code as string, value: item.code }
        })
        setShelfAllList(newRecords)
    }
    const onOk = () => {
        globalPrompt('modal', {
            title: '',
            type: 'warning',
            text: '您是否批量调整仓库货位？',
            okText: '确认',
            onOk: async () => {
                let newList: any = []
                selectedRowKeys.map((item) => {
                    if (selectedIdKeys.includes(item.id)) {
                        newList.push({ ...item, ...data, id: '', detailsId: item.id })
                    } else {
                        newList.push({ ...item, id: '', detailsId: item.id })
                    }
                })
                try {
                    let { retData } = await assetsListService.goodsTransfer(newList);
                    globalPrompt("message", { text: "转移成功！", type: "success" })
                    setVisible(false)
                    resetSearchParam()
                } catch (error) {
                    globalPrompt("message", { text: "转移失败！", type: "warning" })
                    setVisible(false)
                    resetSearchParam()
                }
            },
            cancelText: '取消',
            onCancel: () => { },
        })
    }

    const formItem: IYhFormItemsBox = {
        title: '仓库货位批量调整',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '仓库',
                fieldName: 'warehouseCode',
                options: warehouseList,
                span: 24,
                onSelectChange: changeshelfCode,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '货位',
                fieldName: 'shelfCode',
                options: shelfAllList,
                span: 24,
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        setData({
            ...data,
            ...changedValues,
            warehouseName: data.warehouseCode ? warehouseList.find((item) => item.value === data.warehouseCode)?.label : ''
        })
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: data,
        onChange,
        boxs: [formItem],
    }

    return (
        <Modal
            visible={visible}
            cancelText="取消"
            okText="确认"
            onCancel={() => {
                setVisible(false)
            }}
            onOk={onOk}
        >
            <YhFormBox {...FromConfig} />
        </Modal>
    )
}
